import { FC } from 'react'
import { observer } from 'mobx-react'
import { useStores } from '@/utils'
import MailSvg from '@/public/images/common/untitled-ui-icons/mail-02.svg'
import { IconButton2 } from '@components-v2/atoms/IconButton2'

type Props = {
  href: string
  isDisabled: boolean
  isSendable: boolean
}

export const ProfileContactButton: FC<Props> = observer(({ href, isDisabled, isSendable }) => {
  const { viewer, ui } = useStores()

  const openSetUpProfileToSendDMsModal = () => {
    ui.toggleSetUpProfileToSendDMsModal()
  }

  if (!isSendable) {
    return (
      <IconButton2
        size='md'
        hierarchy='secondary-gray'
        componentType='button'
        disabled={viewer.isSignedIn ? isDisabled : false}
        onClick={openSetUpProfileToSendDMsModal}
        icon={<MailSvg viewBox='0 0 24 24' />}
      />
    )
  }

  return (
    <IconButton2
      size='md'
      hierarchy='secondary-gray'
      componentType='a'
      anchorTarget='_blank'
      disabled={viewer.isSignedIn ? isDisabled : false}
      href={viewer.isSignedIn ? href : '/signin'}
      icon={<MailSvg viewBox='0 0 24 24' />}
    />
  )
})
